export default __webpack_public_path__ + "static/media/stuck-veskovic-poolbau-2.97bcbd9b.jpg";